import { createFileRoute } from '@tanstack/react-router'
import { Suspense, lazy } from 'react'
import { protectedRouteGuard } from '@/utils/routeGuards'

import { Loading } from '@/components/Loading'

const EditClusterPage = lazy(
  () => import('@/features/Clusters/pages/EditClusterPage'),
)

export const Route = createFileRoute('/infra/clusters/edit/$clusterId')({
  beforeLoad: protectedRouteGuard,
  loader: () => ({
    crumb: 'Edit Cluster',
  }),
  component: () => (
    <Suspense fallback={<Loading />}>
      <EditClusterPage />
    </Suspense>
  ),
})
